var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXFullScreenPressed = function SvgXFullScreenPressed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    style: {
      transform: "rotate(90deg)"
    },
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.272 11.572h3.831c.908 0 1.436-.527 1.436-1.428V6.416c0-.52-.396-.9-.923-.9-.52 0-.916.373-.916.9v.38l.154 1.847-1.34-1.414-1.81-1.824a.901.901 0 0 0-.651-.263c-.557 0-.952.395-.952.952 0 .249.102.476.278.644l1.816 1.824 1.421 1.333-1.875-.154h-.469c-.52 0-.9.388-.9.916 0 .527.373.915.9.915Zm7.076 6.98c.52 0 .915-.373.915-.9v-.425l-.154-1.846 1.34 1.413 1.84 1.854a.885.885 0 0 0 .644.263c.564 0 .96-.395.96-.96a.898.898 0 0 0-.28-.644l-1.845-1.846-1.42-1.333 1.874.154h.513c.52 0 .9-.388.9-.915 0-.528-.373-.916-.9-.916H13.86c-.908 0-1.435.527-1.435 1.436v3.764c0 .52.395.901.923.901Z"
  })));
};
export default SvgXFullScreenPressed;